import React, { useMemo, useRef } from 'react'
import PropTypes from 'prop-types'

import { useDocPreview, isSidesPreview } from 'hooks/useDocPreview'
import { ACCEPTED_FILE_TYPES, STATUS_LIST } from 'constants/docUploadConstant'

import CompletedCard from './CompletedCard'
import PendingCard from './PendingCard'
import InprogressCard from './InprogressCard'
import UploadedCard from './UploadedCard'
import ErrorCard from './ErrorCard'
import FileSizeErrorCard from './FileSizeErrorCard'

const { INPROGRESS, UPLOADED, COMPLETED, ERROR, FILESIZEERROR } = STATUS_LIST

const getCardByStatus = (status) => {
    switch (status) {
        case INPROGRESS:
            return InprogressCard
        case UPLOADED:
            return UploadedCard
        case COMPLETED:
            return CompletedCard
        case ERROR:
            return ErrorCard
        case FILESIZEERROR:
            return FileSizeErrorCard
        default:
            return PendingCard
    }
}

const DocCard = ({ status, ...props }) => {
    const fileRef = useRef()
    const { handleToggleDialog, openSidesUpload, onKeyDownHandler } = useDocPreview()

    const selectFile = (event) => {
        if (props.documentId || props.base64Data) {
            handleToggleDialog(event, props)
        } else {
            if (isSidesPreview(props.documentType)) {
                openSidesUpload(props)
            } else {
                fileRef.current.click()
            }
        }
    }

    const handleKeyDown = (e) => {
        onKeyDownHandler(e, selectFile)
    }

    const Card = useMemo(() => getCardByStatus(status), [status])

    return (
        <>
            <input
                onChange={(event) => handleToggleDialog(event, props)}
                onClick={(event) => {
                    event.target.value = null
                }}
                type="file"
                ref={fileRef}
                accept={ACCEPTED_FILE_TYPES}
                hidden
            />
            <Card selectFile={selectFile} onKeyDownHandler={handleKeyDown} {...props} />
        </>
    )
}

DocCard.propTypes = {
    status: PropTypes.string,
    togglePreviewDialog: PropTypes.func,
    documentName: PropTypes.string,
    documentId: PropTypes.string,
    documentType: PropTypes.string,
    base64Data: PropTypes.string
}

export default DocCard
